<template>
  <div class="recent-action">
    <span>
      <slot />
    </span>
    <div class="small-text">
      {{ timeAgo(createdAt) }}
    </div>
  </div>
</template>

<script>

export default {
  props: {
    createdAt: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.recent-action {
  font-size: 14px;
  flex-shrink: 0;

  max-width: 250px;
  padding-right: 15px;

  // In case the content is too long to fit in that max-width, overflow with ellipsis.
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
